// extracted by mini-css-extract-plugin
export default {"userAvatar":"Header_userAvatar__A5LvM","userInfo":"Header_userInfo__1eb5W","title":"Header_title__nbfUw","navBar":"Header_navBar__qU9w1","username":"Header_username__2ji2u"};